import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ValorAdquisicionFormGroup = ({ iError, iTouched, fIsSubmitting, disabled }) => {
  return (
    <Form.Group>
      <Form.Label text='VALOR ADQ.' htmlFor='input-valorAdquisicion' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='valorAdquisicion'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting || disabled}
              min={0}
              id='input-valorAdquisicion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ValorAdquisicionFormGroup)
